import { render } from "./TheCreateButton.vue?vue&type=template&id=073c88e8&scoped=true"
import script from "./TheCreateButton.vue?vue&type=script&lang=js"
export * from "./TheCreateButton.vue?vue&type=script&lang=js"

import "./TheCreateButton.vue?vue&type=style&index=0&id=073c88e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-073c88e8"

export default script